module.exports = __webpack_public_path__ + "img/alternative-contents-empty-list-dark.7afb637c.svg";